import HeroPack from "../HeroPack";

const Hero = () => {
  return <HeroPack />;
};

export default Hero;
